const dermotikEscapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
}[character]));

const dermotikMoney = (cents = 0) => {
  const currency = window.Shopify?.currency?.active || 'TRY';
  return new Intl.NumberFormat('tr-TR', { style: 'currency', currency }).format(Number(cents) / 100);
};

const DERMOTIK_FAVORITES_KEY = 'dermotik_favorites';

function hydrateDermotikImage(image) {
  if (!image || image.dataset.mediaHydrated === 'true') return;
  if (image.dataset.srcset) {
    image.srcset = image.dataset.srcset;
    image.removeAttribute('data-srcset');
  }
  if (image.dataset.src) {
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  }
  image.dataset.mediaHydrated = 'true';
}

function hydrateDermotikVideo(video, autoplay = false) {
  if (!video) return;
  video.muted = true;
  video.defaultMuted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = 'auto';
  video.setAttribute('muted', '');
  video.setAttribute('loop', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  video.autoplay = autoplay;
  video.toggleAttribute('autoplay', autoplay);
  if (video.dataset.mediaHydrated === 'true') return;
  if (video.dataset.src) {
    video.src = video.dataset.src;
    video.removeAttribute('data-src');
  }
  video.querySelectorAll('source[data-src]').forEach((source) => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });
  video.dataset.mediaHydrated = 'true';
  video.load();
}

function primeDermotikVideo(video) {
  if (!video) return;
  hydrateDermotikVideo(video, video.dataset.playRequested === 'true');
}

function requestDermotikVideoPlayback(video) {
  if (!video) return;
  video.dataset.playRequested = 'true';
  if (video.dataset.playQueued === 'true') return;
  video.dataset.playQueued = 'true';
  hydrateDermotikVideo(video, true);
  const playback = video.play();
  video.dataset.playQueued = 'false';
  if (!playback || typeof playback.catch !== 'function') return;
  playback.catch(() => {
    if (video.dataset.playRequested !== 'true') return;
    const retryCount = Number.parseInt(video.dataset.playRetryCount || '0', 10);
    if (retryCount >= 4) return;
    video.dataset.playRetryCount = String(retryCount + 1);
    window.setTimeout(() => {
      if (video.dataset.playRequested !== 'true') return;
      if (video.networkState === HTMLMediaElement.NETWORK_NO_SOURCE) video.load();
      requestDermotikVideoPlayback(video);
    }, 180 * (retryCount + 1));
  });
}

function getDermotikFavorites() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(DERMOTIK_FAVORITES_KEY) || '[]');
    return Array.isArray(saved) ? saved.filter((handle) => typeof handle === 'string') : [];
  } catch {
    return [];
  }
}

function setDermotikFavorites(handles) {
  try {
    window.localStorage.setItem(DERMOTIK_FAVORITES_KEY, JSON.stringify([...new Set(handles)]));
  } catch {
    return;
  }
}

function renderDermotikFavorites() {
  const favorites = getDermotikFavorites();
  const favoriteSet = new Set(favorites);

  document.querySelectorAll('[data-favorite-count]').forEach((count) => {
    count.textContent = favorites.length;
    count.hidden = favorites.length === 0;
  });

  document.querySelectorAll('[data-favorite-toggle]').forEach((button) => {
    const active = favoriteSet.has(button.dataset.productHandle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
  });

  const favoritesPage = document.querySelector('[data-favorites-page]');
  if (!favoritesPage) return;
  let visibleCount = 0;
  favoritesPage.querySelectorAll('[data-favorite-item]').forEach((item) => {
    const visible = favoriteSet.has(item.dataset.favoriteItem);
    item.hidden = !visible;
    if (visible) visibleCount += 1;
  });
  const empty = favoritesPage.querySelector('[data-favorites-empty]');
  const grid = favoritesPage.querySelector('[data-favorites-grid]');
  if (empty) empty.hidden = visibleCount > 0;
  if (grid) grid.hidden = visibleCount === 0;
}

function renderDermotikCart(cart) {
  const layer = document.querySelector('[data-cart-drawer-layer]');
  const itemsContainer = layer?.querySelector('[data-cart-drawer-items]');
  const footer = layer?.querySelector('[data-cart-drawer-footer]');
  if (!layer || !itemsContainer || !footer) return;

  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count;
    count.classList.toggle('is-empty', cart.item_count === 0);
  });
  layer.querySelectorAll('[data-cart-heading-count]').forEach((count) => { count.textContent = cart.item_count; });
  const total = layer.querySelector('[data-cart-total]');
  const subtotal = layer.querySelector('[data-cart-subtotal]');
  const shipping = layer.querySelector('[data-cart-shipping]');
  const rewardMessage = layer.querySelector('[data-cart-reward-message]');
  const rewardPercent = layer.querySelector('[data-cart-reward-percent]');
  const rewardBar = layer.querySelector('[data-cart-reward-bar]');
  const discountRow = layer.querySelector('[data-cart-discount-row]');
  const discountValue = layer.querySelector('[data-cart-discount]');
  const offers = layer.querySelector('[data-cart-offers]');
  const freeShippingThreshold = 25000;
  const qualifyingTotal = cart.items_subtotal_price;
  const earnedFreeShipping = qualifyingTotal >= freeShippingThreshold;
  const percent = Math.min(100, Math.round((qualifyingTotal / freeShippingThreshold) * 100));
  const totalDiscount = Number(cart.total_discount || 0);

  if (total) total.textContent = dermotikMoney(cart.total_price);
  if (subtotal) subtotal.textContent = dermotikMoney(cart.items_subtotal_price);
  if (shipping) shipping.textContent = earnedFreeShipping ? 'Ücretsiz' : 'Ödeme adımında';
  if (rewardMessage) {
    rewardMessage.innerHTML = earnedFreeShipping
      ? 'Ücretsiz kargo kazandınız.'
      : `Ücretsiz kargoya <strong>${dermotikMoney(freeShippingThreshold - qualifyingTotal)}</strong> kaldı`;
  }
  if (rewardPercent) rewardPercent.textContent = `${percent}%`;
  if (rewardBar) rewardBar.style.width = `${percent}%`;
  if (discountRow) discountRow.hidden = totalDiscount <= 0;
  if (discountValue && totalDiscount > 0) discountValue.textContent = `-${dermotikMoney(totalDiscount)}`;
  footer.classList.toggle('is-empty', cart.item_count === 0);
  offers?.classList.toggle('is-empty', cart.item_count === 0);

  if (!cart.item_count) {
    itemsContainer.innerHTML = `
      <div class="cart-drawer__empty">
        <p>Sepetiniz şu anda boş.</p>
        <a class="button" href="/collections/all">Ürünleri keşfet</a>
      </div>`;
    return;
  }

  itemsContainer.innerHTML = cart.items.map((item, index) => {
    const imageSeparator = item.image?.includes('?') ? '&' : '?';
    const image = item.image
      ? `<img src="${dermotikEscapeHtml(item.image)}${imageSeparator}width=180" alt="${dermotikEscapeHtml(item.product_title)}" width="86" height="106" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<small>${dermotikEscapeHtml(item.variant_title)}</small>`
      : '';
    const productType = item.product_type
      ? `<small class="cart-drawer__item-type">${dermotikEscapeHtml(item.product_type)}</small>`
      : '';
    return `
      <article class="cart-drawer__item">
        <a class="cart-drawer__item-image" href="${dermotikEscapeHtml(item.url)}">${image}</a>
        <div class="cart-drawer__item-copy">
          ${productType}
          <a class="cart-drawer__item-title" href="${dermotikEscapeHtml(item.url)}">${dermotikEscapeHtml(item.product_title)}</a>
          ${variant}
          <div class="cart-drawer__item-row">
            <div class="cart-quantity" aria-label="Ürün adedi">
              <button type="button" data-cart-change="${index + 1}" data-cart-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Adedi azalt">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-change="${index + 1}" data-cart-quantity="${item.quantity + 1}" aria-label="Adedi artır">+</button>
            </div>
            <strong>${dermotikMoney(item.final_line_price)}</strong>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-remove="${index + 1}">Kaldır</button>
        </div>
      </article>`;
  }).join('');
}

async function refreshDermotikCart() {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Sepet güncellenemedi.');
  const cart = await response.json();
  renderDermotikCart(cart);
  return cart;
}

function openDermotikCart() {
  const layer = document.querySelector('[data-cart-drawer-layer]');
  const drawer = layer?.querySelector('[data-cart-drawer]');
  if (!layer || !drawer) return;
  layer.hidden = false;
  document.body.classList.add('cart-drawer-open');
  window.requestAnimationFrame(() => {
    layer.classList.add('is-open');
    drawer.focus();
  });
}

function closeDermotikCart() {
  const layer = document.querySelector('[data-cart-drawer-layer]');
  if (!layer || layer.hidden) return;
  layer.classList.remove('is-open');
  document.body.classList.remove('cart-drawer-open');
  window.setTimeout(() => { layer.hidden = true; }, 340);
}

function openDermotikSearch(trigger) {
  const layer = document.querySelector('[data-search-layer]');
  const panel = layer?.querySelector('[data-search-panel]');
  if (!layer || !panel) return;
  document.querySelector('.account-menu[open]')?.removeAttribute('open');
  layer.hidden = false;
  document.body.classList.add('header-search-open');
  trigger?.setAttribute('aria-expanded', 'true');
  window.requestAnimationFrame(() => {
    layer.classList.add('is-open');
    layer.querySelector('[data-search-input]')?.focus();
  });
}

function closeDermotikSearch() {
  const layer = document.querySelector('[data-search-layer]');
  const trigger = document.querySelector('[data-search-trigger]');
  if (!layer || layer.hidden) return;
  layer.classList.remove('is-open');
  document.body.classList.remove('header-search-open');
  trigger?.setAttribute('aria-expanded', 'false');
  window.setTimeout(() => {
    layer.hidden = true;
    trigger?.focus();
  }, 250);
}

function initializeDermotikTheme(root = document) {
  root.querySelectorAll('[data-mobile-menu]').forEach((button) => {
    if (button.dataset.menuReady === 'true') return;
    button.dataset.menuReady = 'true';
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-navigation]');
      if (!menu) return;
      const open = menu.toggleAttribute('data-open');
      menu.hidden = !open;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
    });
  });
  root.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    if (button.dataset.menuCloseReady === 'true') return;
    button.dataset.menuCloseReady = 'true';
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-navigation]');
      const opener = document.querySelector('[data-mobile-menu]');
      if (!menu || !opener) return;
      menu.removeAttribute('data-open');
      menu.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      opener.setAttribute('aria-label', 'Menüyü aç');
      opener.focus();
    });
  });

  root.querySelectorAll('[data-cart-trigger]').forEach((trigger) => {
    if (trigger.dataset.cartTriggerReady === 'true') return;
    trigger.dataset.cartTriggerReady = 'true';
    trigger.addEventListener('click', (event) => {
      if (!document.querySelector('[data-cart-drawer-layer]')) return;
      event.preventDefault();
      refreshDermotikCart().catch(() => {}).finally(openDermotikCart);
    });
  });
  root.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    if (button.dataset.cartCloseReady === 'true') return;
    button.dataset.cartCloseReady = 'true';
    button.addEventListener('click', closeDermotikCart);
  });
  root.querySelectorAll('[data-search-trigger]').forEach((trigger) => {
    if (trigger.dataset.searchTriggerReady === 'true') return;
    trigger.dataset.searchTriggerReady = 'true';
    trigger.addEventListener('click', () => {
      const layer = document.querySelector('[data-search-layer]');
      if (layer?.classList.contains('is-open')) closeDermotikSearch();
      else openDermotikSearch(trigger);
    });
  });
  root.querySelectorAll('[data-search-close]').forEach((button) => {
    if (button.dataset.searchCloseReady === 'true') return;
    button.dataset.searchCloseReady = 'true';
    button.addEventListener('click', closeDermotikSearch);
  });

  root.querySelectorAll('[data-hero]').forEach((hero) => {
    if (hero.dataset.heroReady === 'true') return;
    hero.dataset.heroReady = 'true';
    const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
    const previous = hero.querySelector('[data-hero-prev]');
    const next = hero.querySelector('[data-hero-next]');
    const toggle = hero.querySelector('[data-hero-toggle]');
    if (!slides.length) return;

    let activeIndex = 0;
    let timer;
    let touchStartX = 0;
    let pausedByUser = false;
    const interval = Math.max(3000, Number(hero.dataset.interval) || 5000);
    const autoplay = hero.dataset.autoplay === 'true';

    const hydrateSlide = (slide) => {
      if (!slide || slide.dataset.mediaHydrated === 'true') return;
      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      slide.querySelectorAll('img[data-src], img[data-srcset]').forEach(hydrateDermotikImage);
      slide.dataset.mediaHydrated = 'true';
    };
    const preloadUpcomingSlide = () => {
      if (slides.length < 2) return;
      const preload = () => hydrateSlide(slides[(activeIndex + 1) % slides.length]);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(preload, { timeout: 2200 });
      } else {
        window.setTimeout(preload, 1200);
      }
    };
    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      hydrateSlide(slides[activeIndex]);
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
      preloadUpcomingSlide();
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (
        slides.length > 1 &&
        autoplay &&
        !pausedByUser &&
        !window.Shopify?.designMode &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        timer = window.setInterval(() => show(activeIndex + 1), interval);
      }
    };

    previous?.addEventListener('click', () => { show(activeIndex - 1); start(); });
    next?.addEventListener('click', () => { show(activeIndex + 1); start(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); start(); }));
    toggle?.addEventListener('click', () => {
      pausedByUser = !pausedByUser;
      toggle.setAttribute('aria-pressed', String(pausedByUser));
      toggle.setAttribute('aria-label', pausedByUser ? 'Otomatik geçişi başlat' : 'Otomatik geçişi durdur');
      toggle.textContent = pausedByUser ? '▶' : 'Ⅱ';
      if (pausedByUser) stop(); else start();
    });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    hero.addEventListener('shopify:block:select', (event) => {
      const selectedSlide = event.target.closest('[data-hero-slide]');
      const selectedIndex = slides.indexOf(selectedSlide);
      if (selectedIndex >= 0) {
        stop();
        show(selectedIndex);
      }
    });
    hero.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX || 0; }, { passive: true });
    hero.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
      start();
    }, { passive: true });
    hydrateSlide(slides[0]);
    if (document.readyState === 'complete') preloadUpcomingSlide();
    else window.addEventListener('load', preloadUpcomingSlide, { once: true });
    start();
  });

  root.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    if (productRoot.dataset.productReady === 'true') return;
    productRoot.dataset.productReady = 'true';

    const gallery = productRoot.querySelector('[data-product-gallery]');
    if (gallery) {
      const stage = gallery.querySelector('.product__gallery-stage');
      const mediaItems = Array.from(gallery.querySelectorAll('[data-product-media]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-product-thumbnail]'));
      const galleryPrevious = gallery.querySelector('[data-product-gallery-previous]');
      const galleryNext = gallery.querySelector('[data-product-gallery-next]');
      const dialog = productRoot.querySelector('[data-product-media-dialog]');
      const dialogImage = dialog?.querySelector('[data-product-media-dialog-image]');
      const dialogClose = dialog?.querySelector('[data-product-media-dialog-close]');
      const dialogPrevious = dialog?.querySelector('[data-product-media-dialog-previous]');
      const dialogNext = dialog?.querySelector('[data-product-media-dialog-next]');
      const dialogThumbnails = Array.from(dialog?.querySelectorAll('[data-product-media-dialog-thumbnail]') || []);
      let activeIndex = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let ignoreClickUntil = 0;

      const showMedia = (index) => {
        if (!mediaItems.length) return;
        activeIndex = (index + mediaItems.length) % mediaItems.length;
        mediaItems.forEach((item, itemIndex) => {
          item.hidden = itemIndex !== activeIndex;
        });
        thumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-selected', String(active));
        });
        dialogThumbnails.forEach((thumbnail, thumbnailIndex) => {
          const active = thumbnailIndex === activeIndex;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', String(active));
        });
      };

      const openMediaDialog = (index) => {
        showMedia(index);
        const media = mediaItems[activeIndex];
        const source = media?.dataset.fullImage;
        if (!dialog || !dialogImage || !source) return;
        dialogImage.src = source;
        dialogImage.alt = media.querySelector('img')?.alt || document.title;
        if (!dialog.open) dialog.showModal();
      };

      const updateDialog = (direction) => {
        const index = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        openMediaDialog(index);
      };

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = Number(thumbnail.dataset.mediaIndex);
          if (Number.isInteger(index)) showMedia(index);
        });
      });

      dialogThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const index = Number(thumbnail.dataset.mediaIndex);
          if (Number.isInteger(index)) openMediaDialog(index);
        });
      });

      galleryPrevious?.addEventListener('click', () => showMedia(activeIndex - 1));
      galleryNext?.addEventListener('click', () => showMedia(activeIndex + 1));

      mediaItems.forEach((media, index) => {
        media.addEventListener('click', () => {
          if (Date.now() < ignoreClickUntil) return;
          openMediaDialog(index);
        });
      });

      stage?.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        touchStartX = touch?.clientX || 0;
        touchStartY = touch?.clientY || 0;
      }, { passive: true });

      stage?.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = (touch?.clientX || 0) - touchStartX;
        const deltaY = (touch?.clientY || 0) - touchStartY;
        if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
          ignoreClickUntil = Date.now() + 450;
          showMedia(activeIndex + (deltaX < 0 ? 1 : -1));
        }
      }, { passive: true });

      let dialogTouchStartX = 0;
      let dialogTouchStartY = 0;
      dialogClose?.addEventListener('click', () => dialog.close());
      dialogPrevious?.addEventListener('click', () => updateDialog(-1));
      dialogNext?.addEventListener('click', () => updateDialog(1));
      dialog?.addEventListener('touchstart', (event) => {
        const touch = event.touches[0];
        dialogTouchStartX = touch?.clientX || 0;
        dialogTouchStartY = touch?.clientY || 0;
      }, { passive: true });
      dialog?.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const deltaX = (touch?.clientX || 0) - dialogTouchStartX;
        const deltaY = (touch?.clientY || 0) - dialogTouchStartY;
        if (Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
          updateDialog(deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }

    const quantityInput = productRoot.querySelector('.quantity-field input[name="quantity"]');
    productRoot.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Math.floor(Number(quantityInput.value) || 1) - 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    productRoot.querySelector('[data-quantity-increase]')?.addEventListener('click', () => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Math.floor(Number(quantityInput.value) || 0) + 1);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const variantSelect = productRoot.querySelector('select[name="id"]');
    if (!variantSelect) return;
    const price = productRoot.querySelector('[data-product-price]');
    const stock = productRoot.querySelector('[data-product-stock]');
    const addButton = productRoot.querySelector('[data-add-to-cart]');

    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      const available = option?.dataset.available === 'true';
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
      if (stock && option?.dataset.stockText) stock.textContent = option.dataset.stockText;
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantSelect.value);
      window.history.replaceState({}, '', url);
    });
  });

  root.querySelectorAll('[data-sort-by]').forEach((select) => {
    if (select.dataset.sortReady === 'true') return;
    select.dataset.sortReady = 'true';
    select.addEventListener('change', () => select.form?.submit());
  });

  root.querySelectorAll('[data-filter-toggle]').forEach((button) => {
    if (button.dataset.filterReady === 'true') return;
    button.dataset.filterReady = 'true';
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!panel) return;
    const close = () => {
      panel.hidden = true;
      panel.removeAttribute('data-open');
      button.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('filter-panel-open');
    };
    button.addEventListener('click', () => {
      const opening = panel.hidden;
      panel.hidden = !opening;
      panel.toggleAttribute('data-open', opening);
      button.setAttribute('aria-expanded', String(opening));
      document.body.classList.toggle('filter-panel-open', opening);
      if (opening) panel.querySelector('button, input, select')?.focus();
    });
    panel.querySelector('[data-filter-close]')?.addEventListener('click', close);
  });

  root.querySelectorAll('[data-featured-slider], [data-reels-slider]').forEach((slider) => {
    if (slider.dataset.sliderReady === 'true') return;
    slider.dataset.sliderReady = 'true';
    const track = slider.querySelector('[data-featured-slider-track], [data-reels-slider-track]');
    const previous = slider.querySelector('[data-featured-slider-prev], [data-reels-slider-prev]');
    const next = slider.querySelector('[data-featured-slider-next], [data-reels-slider-next]');
    const controls = slider.querySelector('[data-slider-controls]');
    if (!track || !previous || !next) return;

    const step = () => {
      const card = track.querySelector('.product-card, .reel-card');
      if (!card) return track.clientWidth;
      const gap = Number.parseFloat(window.getComputedStyle(track).gap) || 0;
      const cardCount = card.classList.contains('reel-card') ? 1 : 2;
      return (card.getBoundingClientRect().width + gap) * cardCount;
    };
    const update = () => {
      const max = Math.max(0, track.scrollWidth - track.clientWidth);
      if (controls) controls.hidden = max <= 4;
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= max - 4;
    };

    previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  root.querySelectorAll('[data-product-card]').forEach((card) => {
    if (card.dataset.secondaryImageReady === 'true') return;
    card.dataset.secondaryImageReady = 'true';
    const secondaryImage = card.querySelector('.product-card__image--secondary');
    if (!secondaryImage) return;
    const hydrateSecondaryImage = () => hydrateDermotikImage(secondaryImage);
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      card.addEventListener('pointerenter', hydrateSecondaryImage, { once: true, passive: true });
    }
    card.addEventListener('focusin', hydrateSecondaryImage, { once: true });
  });

  root.querySelectorAll('[data-reels-slider]').forEach((reelsSlider) => {
    const videos = [...reelsSlider.querySelectorAll('.reel-card__video')];
    const visibility = new Map(videos.map((video) => [video, 0]));
    const mobileView = () => window.matchMedia('(max-width: 760px)').matches;
    const saveData = navigator.connection?.saveData === true;
    const primeInitialVideos = () => {
      if (saveData) {
        primeDermotikVideo(videos[0]);
        return;
      }
      videos.forEach((video) => primeDermotikVideo(video));
    };
    const primeNearby = (video) => {
      const index = videos.indexOf(video);
      if (index < 0) return;
      primeDermotikVideo(videos[index]);
      if (!saveData) {
        primeDermotikVideo(videos[index + 1]);
        primeDermotikVideo(videos[index - 1]);
      }
    };
    if (!saveData) {
      if (document.readyState === 'complete') primeInitialVideos();
      else window.addEventListener('load', primeInitialVideos, { once: true });
    }
    videos.forEach((video) => {
      if (video.dataset.videoReady === 'true') return;
      video.dataset.videoReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      video.addEventListener('canplay', () => {
        if (video.dataset.playRequested === 'true' && video.paused) requestDermotikVideoPlayback(video);
      });
      video.addEventListener('playing', () => {
        video.dataset.playRetryCount = '0';
        if (video.dataset.frameRevealQueued === 'true') return;
        video.dataset.frameRevealQueued = 'true';
        const revealFrame = () => {
          video.dataset.frameRevealQueued = 'false';
          if (video.paused || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;
          video.closest('.reel-card__media')?.classList.add('is-video-playing');
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(() => requestAnimationFrame(revealFrame));
        } else {
          requestAnimationFrame(() => requestAnimationFrame(revealFrame));
        }
      });
    });
    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      primeInitialVideos();
      videos.forEach((video) => requestDermotikVideoPlayback(video));
      return;
    }

    const updatePlayback = () => {
      videos.forEach((video) => {
        const minimumVisibility = mobileView() ? .25 : .2;
        const shouldPlay = (visibility.get(video) || 0) >= minimumVisibility;
        if (shouldPlay) {
          primeNearby(video);
          video.muted = true;
          requestDermotikVideoPlayback(video);
        } else {
          video.dataset.playRequested = 'false';
          video.autoplay = false;
          video.removeAttribute('autoplay');
          video.pause();
        }
      });
    };

    const sectionPreloader = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      primeInitialVideos();
      observer.disconnect();
    }, { rootMargin: '900px 0px' });
    sectionPreloader.observe(reelsSlider);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => visibility.set(entry.target, entry.intersectionRatio));
      updatePlayback();
    }, { rootMargin: '40px 0px', threshold: [0, .2, .35, .6] });
    videos.forEach((video) => observer.observe(video));
  });

  renderDermotikFavorites();
}

document.addEventListener('DOMContentLoaded', () => initializeDermotikTheme());
document.addEventListener('shopify:section:load', (event) => initializeDermotikTheme(event.target));
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form || !document.querySelector('[data-cart-drawer-layer]')) return;
  event.preventDefault();
  const submitButton = form.querySelector('[type="submit"]');
  if (submitButton) submitButton.disabled = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Ürün sepete eklenemedi.');
    await refreshDermotikCart();
    openDermotikCart();
  } catch (error) {
    window.location.href = form.action;
  } finally {
    if (submitButton) submitButton.disabled = false;
  }
}, true);
document.addEventListener('click', async (event) => {
  const favoriteButton = event.target.closest('[data-favorite-toggle]');
  if (favoriteButton) {
    event.preventDefault();
    const handle = favoriteButton.dataset.productHandle;
    const favorites = getDermotikFavorites();
    const nextFavorites = favorites.includes(handle)
      ? favorites.filter((savedHandle) => savedHandle !== handle)
      : [...favorites, handle];
    setDermotikFavorites(nextFavorites);
    renderDermotikFavorites();
    return;
  }

  const cartButton = event.target.closest('[data-cart-remove], [data-cart-change]');
  if (!cartButton) return;
  cartButton.disabled = true;
  const line = Number(cartButton.dataset.cartRemove || cartButton.dataset.cartChange);
  const quantity = cartButton.hasAttribute('data-cart-remove') ? 0 : Number(cartButton.dataset.cartQuantity);
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('Sepet güncellenemedi.');
    renderDermotikCart(await response.json());
  } finally {
    cartButton.disabled = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (document.querySelector('[data-cart-drawer-layer].is-open')) {
    closeDermotikCart();
    return;
  }
  if (document.querySelector('[data-search-layer].is-open')) {
    closeDermotikSearch();
    return;
  }
  const menu = document.querySelector('[data-mobile-navigation][data-open]');
  const button = document.querySelector('[data-mobile-menu][aria-expanded="true"]');
  if (!menu || !button) return;
  menu.removeAttribute('data-open');
  menu.hidden = true;
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-label', 'Menüyü aç');
  button.focus();
});

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Öneri isteği başarısız: ${response.status}`);
          return response.text();
        })
        .then((text) => {
          const documentFragment = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = documentFragment.querySelector('product-recommendations');
          if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  });
}


function initInfluencerExperience(root = document) {
  root.querySelectorAll('[data-influencer-experience]').forEach((section) => {
    if (section.dataset.influencerReady === 'true') return;
    const slider = section.querySelector('[data-influencer-slider]');
    const track = section.querySelector('[data-horizontal-slider]');
    const previous = section.querySelector('[data-influencer-prev]');
    const next = section.querySelector('[data-influencer-next]');
    const modal = section.querySelector('[data-influencer-modal]');
    const cards = [...section.querySelectorAll('[data-influencer-open]')];
    const slides = [...section.querySelectorAll('[data-influencer-slide]')];
    if (!slider || !track || !previous || !next) return;
    section.dataset.influencerReady = 'true';
    let activeIndex = 0;

    const mobileView = () => window.matchMedia('(max-width: 700px)').matches;
    const pauseVideos = (collection, except = null) => collection.forEach((video) => {
      if (video !== except) video.pause();
    });
    const cardVideos = [...section.querySelectorAll('.influencer-reel__video')];
    const modalVideos = [...section.querySelectorAll('.influencer-modal__video')];
    const saveData = navigator.connection?.saveData === true;
    cardVideos.forEach((video) => {
      const previewDuration = Number.parseFloat(video.dataset.previewDuration || '0');
      if (Number.isFinite(previewDuration) && previewDuration > 0) {
        video.addEventListener('timeupdate', () => {
          if (video.currentTime < previewDuration) return;
          video.currentTime = 0;
        });
      }
      video.addEventListener('playing', () => {
        if (video.dataset.frameRevealQueued === 'true') return;
        video.dataset.frameRevealQueued = 'true';
        const revealFrame = () => {
          video.dataset.frameRevealQueued = 'false';
          if (video.paused || video.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) return;
          video.closest('.influencer-reel__media')?.classList.add('is-video-playing');
        };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(() => requestAnimationFrame(revealFrame));
        } else {
          requestAnimationFrame(() => requestAnimationFrame(revealFrame));
        }
      });
    });
    const primeInfluencerVideos = () => {
      if (saveData) {
        primeDermotikVideo(cardVideos[0]);
        return;
      }
      cardVideos.forEach((video) => primeDermotikVideo(video));
    };
    modalVideos.forEach((video) => {
      video.loop = true;
      video.setAttribute('loop', '');
    });
    const toggleVideo = (video) => {
      if (!video) return;
      video.muted = false;
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    };
    const step = () => Math.max(track.clientWidth * 0.78, track.firstElementChild?.getBoundingClientRect().width || 280);
    const updateArrows = () => {
      previous.hidden = false;
      next.hidden = false;
      previous.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    previous.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows, { passive: true });

    if ('IntersectionObserver' in window) {
      const sectionPreloader = new IntersectionObserver((entries, observer) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        primeDermotikVideo(cardVideos[0]);
        observer.disconnect();
      }, { rootMargin: '360px 0px' });
      sectionPreloader.observe(section);

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && (mobileView() || entry.intersectionRatio > .65)) {
            video.muted = true;
            requestDermotikVideoPlayback(video);
          } else {
            video.dataset.playRequested = 'false';
            video.autoplay = false;
            video.removeAttribute('autoplay');
            video.pause();
          }
        });
      }, { root: mobileView() ? track : null, threshold: [.2, .65] });
      cardVideos.forEach((video) => observer.observe(video));
    } else {
      primeInfluencerVideos();
      cardVideos.forEach((video) => requestDermotikVideoPlayback(video));
    }

    const renderSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.hidden = !active;
        const video = slide.querySelector('video');
        if (active) {
          if (video) {
            hydrateDermotikVideo(video);
            video.muted = false;
            video.currentTime = 0;
            video.play().catch(() => {});
          }
        } else if (video) {
          video.pause();
        }
      });
    };
    const closeModal = () => {
      if (!modal) return;
      modalVideos.forEach((video) => video.pause());
      document.body.classList.remove('influencer-modal-open');
      if (modal.open) modal.close();
    };
    cards.forEach((card) => {
      const openCard = (event) => {
        if (event?.target?.closest('form, button, a')) return;
        if (!modal) return;
        renderSlide(Number(card.dataset.influencerOpen) || 0);
        if (typeof modal.showModal === 'function') {
          document.body.classList.add('influencer-modal-open');
          modal.showModal();
        }
      };
      card.addEventListener('click', openCard);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openCard();
        }
      });
    });
    section.querySelector('[data-influencer-close]')?.addEventListener('click', closeModal);
    section.querySelector('[data-influencer-modal-prev]')?.addEventListener('click', () => renderSlide(activeIndex - 1));
    section.querySelector('[data-influencer-modal-next]')?.addEventListener('click', () => renderSlide(activeIndex + 1));
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal?.addEventListener('close', () => {
      document.body.classList.remove('influencer-modal-open');
    });
    modalVideos.forEach((video) => video.addEventListener('click', () => toggleVideo(video)));
    let touchStartY = 0;
    let wheelLock = false;
    modal?.addEventListener('touchstart', (event) => {
      touchStartY = event.touches[0]?.clientY || 0;
    }, { passive: true });
    modal?.addEventListener('touchend', (event) => {
      const touchEndY = event.changedTouches[0]?.clientY || 0;
      const distance = touchEndY - touchStartY;
      if (Math.abs(distance) > 48) renderSlide(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });
    modal?.addEventListener('wheel', (event) => {
      if (wheelLock || Math.abs(event.deltaY) < 18) return;
      wheelLock = true;
      renderSlide(activeIndex + (event.deltaY > 0 ? 1 : -1));
      window.setTimeout(() => { wheelLock = false; }, 450);
    }, { passive: true });
    modal?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') renderSlide(activeIndex - 1);
      if (event.key === 'ArrowRight') renderSlide(activeIndex + 1);
    });
    updateArrows();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initInfluencerExperience);
} else {
  initInfluencerExperience();
}
